<template>
  <div v-if="product">
    <div class="box-toggle-switch">
      <template v-if="arrayFnskuKbn.length">
        <input type="checkbox" v-model="product.fnskuKbn" class="switch-input" :id="`fnsku-kbn-${product.asin}`">
        <label @click="update()" :for="`fnsku-kbn-${product.asin}`" class="switch-label"></label>
        <span :class="`${getStatusItem.class} switch-title`">{{ getStatusItem.status }}</span>
      </template>
      <template v-else>
        <input type="checkbox" :checked="false" class="switch-input">
        <label class="switch-label switch-label-gray"></label>
        <span class="text-gray switch-title">FNSKUを利用しない</span>
      </template>
    </div>
    <div class="m-t-sm">
      <template v-if="product.fnskuKbn">
        <select v-if="arrayFnskuKbn.length > 1" name="fnsku-kbn" v-model="product.fnsku" :id="`fnsku-kbn-select-${product.asin}`" class="form-control" @change="changeFnsku()">
          <option v-for="(arrItem, arrIndex) in arrayFnskuKbn" :key="arrIndex" :value="arrItem">{{ arrItem }}</option>
        </select>
        <div v-else-if="arrayFnskuKbn.length === 1" class="m-t">
          {{ product.fnsku }}
          <input type="hidden" v-model="product.fnsku">
        </div>
        <div v-else class="m-t">
          <div class="text-gray m-t">{{ formatFnsku }}</div>
        </div>
      </template>
      <template v-else>
        <div class="text-gray m-t">{{ formatFnsku }}</div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getStatusItem () {
      let item = {
        status: 'FNSKUを利用しない',
        class: 'text-gray'
      }
      let yamatoOfferFnskuKbn = this.product.fnskuKbn
      if (yamatoOfferFnskuKbn) {
        item.status = 'FNSKUを利用する'
        item.class = 'text-red'
      }
      return item
    },
    arrayFnskuKbn () {
      let arrayFnskuKbn = []
      let arrayInventoryFnskuKbn = this.product.arrayInventoryFnskuKbn
      if (arrayInventoryFnskuKbn && arrayInventoryFnskuKbn.length) {
        arrayFnskuKbn = arrayInventoryFnskuKbn
      }
      return arrayFnskuKbn
    },
    formatFnsku () {
      return `${this.$store.getters.getUser.sellerId.replaceAll('SSC-', '')}-${this.product.asin}-00`
    }
  },
  methods: {
    update () {
      if (!this.product.fnskuKbn) {
        let arrayInventoryFnskuKbn = this.product.arrayInventoryFnskuKbn
        let goodsLatestSkuKbn = this.product.goodsLatestSkuKbn
        if (arrayInventoryFnskuKbn.length) {
          let fnskuIndex = arrayInventoryFnskuKbn.indexOf(goodsLatestSkuKbn)
          if (fnskuIndex > -1) {
            this.product.fnsku = arrayInventoryFnskuKbn[fnskuIndex]
          } else {
            this.product.fnsku = arrayInventoryFnskuKbn[0]
          }
        } else {
          this.product.fnsku = this.formatFnsku
          this.product.fnskuKbn = false
        }
      } else {
        this.product.fnsku = this.formatFnsku
      }
      setTimeout(() => {
        this.$emit('update', this.product)
      }, 400)
    },
    changeFnsku () {
      this.$emit('update', this.product)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/FnskuKbnItem.vue